import React from 'react'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import PrivatePageSF from '../../templates/PrivatePageSF.js'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import ProjectUserListUI from '../../components/projectapp/projectUser/ProjectUserListUI'
import ProjectUserDeleteModalUI from '../../components/projectapp/projectUser/ProjectUserDeleteModalUI'
import ProjectUserUpdateModalUI from '../../components/projectapp/projectUser/ProjectUserUpdateModalUI'

const ProjectUserListPageUI = ({context, messageList, project, projectUserList, filteredProjectUserList,
    // filters
    memberFilter, nonMemberFilter, searchFilter,
    onMemberFilterClick, onNonMemberFilterClick, onSearchFilterChange,
    // form
    successMsg, errorList, setErrorList,
    // modes
    selectedCount, updateMode, deleteMode, submitted,
    // event handlers
    onRowClick, onRefreshClick, onUpdateClick, onDeleteClick,
    // event handlers in modals
    onConfirmInviteClick, onConfirmUpdateClick, onConfirmDeleteClick, onCancelClick,
    // update form
    roleId, roleList, onRoleIdChange
  }) =>
  <PrivatePageSF context={context} className='pg_prj_users'
    backLink={project ? `/projects/${project.projectId}/tasks` : '/projects'}
    centered={!projectUserList && !errorList}
    messageList={messageList} headerMessageKey='c_project_users'
    subHeaderText={`${project ? project.projectName : ''}`}
  >
    {
      !projectUserList && !errorList &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      projectUserList && projectUserList.length !== 0 &&
      <div>
        <PageTitleUI context={context} goBack={true}
          backLink={project ? `/projects/${project.projectId}/tasks` : '/projects'}
          messageList={messageList} titleMessageKey='c_project_users'
          subTitleText={`${project ? project.projectName : ''}`}
        />
        <ProjectUserListUI
          context={context}
          project={project}
          messageList={messageList}
          projectUserList={filteredProjectUserList}
          // filters
          memberFilter={memberFilter}
          nonMemberFilter={nonMemberFilter}
          searchFilter={searchFilter}
          onMemberFilterClick={onMemberFilterClick}
          onNonMemberFilterClick={onNonMemberFilterClick}
          onSearchFilterChange={onSearchFilterChange}
          // actions
          selectedCount={selectedCount}
          onRefreshClick={onRefreshClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onRowClick={onRowClick}
        />
      </div>
    }

    <ProjectUserUpdateModalUI
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      selectedCount={selectedCount}
      updateMode={updateMode}
      onCancelClick={onCancelClick}
      onConfirmUpdateClick={onConfirmUpdateClick}
      submitted={submitted}
      // update form
      roleId={roleId}
      roleList={roleList}
      onRoleIdChange={onRoleIdChange}
    />

    <ProjectUserDeleteModalUI
      context={context}
      messageList={messageList}
      successMsg={successMsg}
      errorList={errorList}
      setErrorList={setErrorList}
      deleteMode={deleteMode}
      onCancelClick={onCancelClick}
      onConfirmDeleteClick={onConfirmDeleteClick}
      submitted={submitted}
    />
  </PrivatePageSF>

export default ProjectUserListPageUI
